$(function () {
  'use strict'

  $('.preloader').fadeOut()
})
